function parseBool(v: unknown): boolean {
  if (typeof v !== 'string') return false;
  const s = v.trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes';
}

/**
 * Billing gate — controls whether purchase CTAs are shown:
 *   - "Buy credit pack" cards on /credits
 *   - "Upgrade" subscription CTAs on /credits
 *   - Header credits badge is "manage" affordance vs read-only
 *
 * OFF (default) means: users can still see their credit balance and use the
 * free credits they got at signup, but there's no way to spend money yet.
 * Flip to true after Stripe prices / credit counts are finalised.
 */
export const BILLING_ENABLED: boolean = parseBool(import.meta.env.VITE_ENABLE_BILLING);
